import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AdminModule } from '@/store/modules/admin';
import { isValidMobile } from '@/utils/validate';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.validateMobileNumber = (rule, value, callback) => {
      if (!isValidMobile(value)) {
        callback(new Error('Please enter valid mobile number'));
      } else {
        callback();
      }
    };
    this.loginForm = {
      mobileNumber: ''
    };
    this.loginRules = {
      mobileNumber: [{
        validator: this.validateMobileNumber,
        trigger: 'blur'
      }]
    };
    this.loading = false;
  }
  requestOtp() {
    this.$refs.loginForm.validate(async valid => {
      if (valid) {
        this.loading = true;
        try {
          // Call the API to request OTP
          const response = await AdminModule.requestOtp(this.loginForm.mobileNumber);
          const {
            hash,
            mobileNumber,
            otpSent
          } = response.otp;
          if (otpSent) {
            this.$router.push({
              path: '/admin-verify-otp',
              query: {
                hash,
                mobileNumber
              }
            });
          } else {
            return false;
          }
        } catch (error) {
          this.loading = false;
        }
      } else {
        return false;
      }
    });
  }
};
default_1 = __decorate([Component({
  name: 'Login'
})], default_1);
export default default_1;